<!-- Do not change this file. -->
<template>
  <div class="container">
    <div class="row justify-content-center my-5">
      <div class="col-12 col-sm-10 col-md-8 col-lg-6">
        <div class="alert alert-danger border-danger text-dark shadow-sm">
          <div class="d-flex d-row">
            <div class="ms-3 me-5 my-auto">
              <i class="text-danger bi bi-exclamation-circle-fill fs-1"></i>
            </div>
            <div class="text-start">
              <h2>Session Expired</h2>
              <p>
                Your session has expired. Any unsaved changes have been lost.
                When your connection is restored you may continue using the
                application.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertSessionExpired"
};
</script>
